
import { defineComponent, onMounted, ref, computed } from "vue";
import JsBarcode from "jsbarcode";

export default defineComponent({
  props: {
    product: {
      type: Object,
      required: true,
    },
    isCampaign: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props) {
    const smallText = ref(false);

    onMounted(() => {
      if (props.product.barcode) {
        try {
          JsBarcode("#barcode", props.product.barcode, {
            width: 2,
            height: 40,
          });
        } catch (error) {
          console.error("Something went wrong while creating barcode");
          console.error(error);
        }
      }

      window.print();

      if (props.product.name.split("").length > 35) {
        smallText.value = true;
      }

      window.onafterprint = window.close;
    });

    const priceIncMva = computed(() => {
      return props.product.price * (1 + props.product.mva_fraction);
    });

    return {
      smallText,
      priceIncMva,
    };
  },
});
